import { sortArrayByKey } from '@/helpers'

export default {
  assessmentConfigs: (state) => {
    return state.assessmentConfigs
  },
  assessmentConfigsPromoted: (state, getters) => {
    let result = []
    for (let value of getters['assessmentConfigs']) {
      // Tasks are in sorted order, as soon as we find a <0, abort the loop
      if (value.position < 0) {
        break
      }
      result.push(value)
    }
    return result.sort(sortArrayByKey('name'))
  }
}
